// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:full-screen .icon-resize:before {
  content: '\\e86e'; /* see .icon-resize-small:before */
}

:-moz-full-screen .icon-resize:before {
  content: '\\e86e'; /* see .icon-resize-small:before */
}

:-ms-full-screen .icon-resize:before {
  content: '\\e86e'; /* see .icon-resize-small:before */
}

:-webkit-full-screen .icon-resize:before {
  content: '\\e86e'; /* see .icon-resize-small:before */
}

.icon-resize:before {
  content: '\\e86d'; /* see .icon-resize-full:before */
}

.icon-resize:before {
  content: '\\e86d'; /* see .icon-resize-full:before */
}

.icon-resize:before {
  content: '\\e86d'; /* see .icon-resize-full:before */
}

.icon-resize:before {
  content: '\\e86d'; /* see .icon-resize-full:before */
}
`, "",{"version":3,"sources":["webpack://./client/css/fullscreen.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB,EAAE,kCAAkC;AACtD;;AAEA;EACE,gBAAgB,EAAE,kCAAkC;AACtD;;AAEA;EACE,gBAAgB,EAAE,kCAAkC;AACtD;;AAEA;EACE,gBAAgB,EAAE,kCAAkC;AACtD;;AAEA;EACE,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;EACE,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;EACE,gBAAgB,EAAE,iCAAiC;AACrD;;AAEA;EACE,gBAAgB,EAAE,iCAAiC;AACrD","sourcesContent":[":full-screen .icon-resize:before {\n  content: '\\e86e'; /* see .icon-resize-small:before */\n}\n\n:-moz-full-screen .icon-resize:before {\n  content: '\\e86e'; /* see .icon-resize-small:before */\n}\n\n:-ms-full-screen .icon-resize:before {\n  content: '\\e86e'; /* see .icon-resize-small:before */\n}\n\n:-webkit-full-screen .icon-resize:before {\n  content: '\\e86e'; /* see .icon-resize-small:before */\n}\n\n.icon-resize:before {\n  content: '\\e86d'; /* see .icon-resize-full:before */\n}\n\n.icon-resize:before {\n  content: '\\e86d'; /* see .icon-resize-full:before */\n}\n\n.icon-resize:before {\n  content: '\\e86d'; /* see .icon-resize-full:before */\n}\n\n.icon-resize:before {\n  content: '\\e86d'; /* see .icon-resize-full:before */\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
